import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';

import DirectMessagesMenu from './DirectMessagesMenu';

import '@/pages/profile/channels/styles/ChannelLayout.css'; // Reuse the same layout CSS

export default function DirectMessagesLayout() {
  const t = useTranslations('common.profile.channels');
  const { user_username } = useParams();
  const chatActive = Boolean(user_username);

  useEffect(() => {
    document.body.classList.add('dm-layout-page');
    return () => {
      document.body.classList.remove('dm-layout-page');
    };
  }, []);

  return (
    <div className={`channel-layout__container ${chatActive ? 'chat-active' : ''}`}>
      <aside className="channel-layout__sidebar">
        <DirectMessagesMenu />
      </aside>
      <main className={`channel-layout__chat ${!chatActive ? 'channel-layout__chat--empty' : ''}`}>
        {
          user_username
            ? <Outlet />
            : (
              <div className="channel-layout__empty-state">
                <img
                  className="channel-layout__empty-illustration"
                  src="/assets/svg/Chat_Illustration.png"
                  alt="Chat illustration"
                />
                <p className="channel-layout__empty-text">{t('layout.private_chat_empty')}</p>
              </div>
            )
        }
      </main>
    </div>
  );
}
